import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderHandlingRequirements extends Layout {
    labelNoneSelected: Label;
    panelOrderHandlingRequirements: Panel;
    sourceBrltlOrderHdrXFgp: DataSource;
    sourceHandlingRequirements: DataSource;
    tableHdrs: Table;
}
